var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { EventCardPropsMapper } from "../../../../../helpers/CardProps";
import { RenderCard } from "../RenderCard/RenderCard";
export var renderInternalEvents = function (state, endIndex, startIndex, events, cms, dict) {
    var innerView = [];
    for (startIndex; startIndex < endIndex; startIndex++) {
        var sportEvent = events[startIndex];
        var props = EventCardPropsMapper[sportEvent.type](state, sportEvent, cms, dict);
        innerView.push(React.createElement(RenderCard, __assign({ key: "k_card_" + startIndex }, props)));
    }
    return innerView;
};
//# sourceMappingURL=renderInternalEvents.js.map